import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { FilterDto, FilterItemDto, FilterTypeEnum, getFilters } from '@creditsights/api-ui-web';
import { queryKeys } from '../queryKeyFactory';

const optionsToMap = (options: FilterItemDto[], type: FilterTypeEnum): Record<string, FilterTypeEnum> =>
  options.reduce((acc, tag) => {
    const newMap = { ...acc, [tag.tagId]: type };
    return tag.children ? { ...newMap, ...optionsToMap(tag.children, type) } : newMap;
  }, {});

export default (): Record<string, FilterTypeEnum> | undefined => {
  const { data } = useQuery<FilterDto[], Error>(queryKeys.fetchFilters.all, getFilters);

  return useMemo(() => {
    return data?.reduce((acc, filter) => {
      return { ...acc, ...optionsToMap(filter.options, filter.type) };
    }, {});
  }, [data]);
};
